import PropTypes from 'prop-types';
import React from 'react';

import Container from 'components/Grid/Container';
import RichText from 'components/RichText';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const CustomCollectionDescriptionModule = ({ content }) => {
  if (Object.keys(content).length === 0) return null;

  return (
    <div className="CustomCollectionDescriptionModule">
      <Container className="CustomCollectionDescriptionModule__container">
        <RichText content={content} />
      </Container>

      <style jsx global>
        {`
          .CustomCollectionDescriptionModule__container.Container {
            padding-top: ${Theme.get('spacing') * 5}px;
          }

          .CustomCollectionDescriptionModule__container.Container .typography--secondary-heading {
            margin-bottom: ${Theme.get('spacing') * 2}px;
            font-size: ${Theme.get('font-size-large-px')};
          }

          .CustomCollectionDescriptionModule__container.Container .Paragraph {
            font-size: ${Theme.get('font-size-description-px')};
          }

          @media ${largeUp} {
            .CustomCollectionDescriptionModule__container.Container {
              padding-top: ${Theme.get('spacing') * 15}px;
            }

            .CustomCollectionDescriptionModule__container.Container .typography--secondary-heading {
              margin-bottom: ${Theme.get('spacing') * 4}px;
              font-size: ${Theme.get('font-size-larger-px')};
            }
          }
        `}
      </style>
    </div>
  );
};

CustomCollectionDescriptionModule.propTypes = {
  content: PropTypes.shape({}),
};

CustomCollectionDescriptionModule.defaultProps = {
  content: {},
};

export default CustomCollectionDescriptionModule;
